module.exports = __webpack_public_path__ + "invalid_straight.svg?b7e61e48934d98628a4ddcf670a3e2ac";


//////////////////
// WEBPACK FOOTER
// ./src/assets/diving_icons/invalid_straight.svg
// module id = 175
// module chunks = 0